import CalendarIcon from "@mui/icons-material/CalendarToday"
import { PropertyContactCreate } from "./property_contacts"

const propertyContactsResource = {
  icon: CalendarIcon,
  create: PropertyContactCreate,
}

export default propertyContactsResource
